export const indexEducationalBackgroundGroupsPath: string = "/educationalBackgroundGroups";
export const newEducationalBackgroundGroupsPath: string = "/educationalBackgroundGroups/new";
export const showEducationalBackgroundGroupsPath: string = "/educationalBackgroundGroups/:id";
export const showEducationalBackgroundGroupsPathCreator = (id: number|string): string => `/educationalBackgroundGroups/${id}`
export const editEducationalBackgroundGroupsPath: string = "/educationalBackgroundGroups/:id/edit"
export const editEducationalBackgroundGroupsPathCreator = (id: number|string): string => `/educationalBackgroundGroups/${id}/edit`
